import api from './api';
import apiWithRefreshToken from './apiWithRefreshToken';

const API_GATEWAY_URL_CUSTOMER = process.env.API_GATEWAY_URL_CUSTOMER;

export const getPdpAll = (isAll: boolean = false, isUseGatewayAPI?: boolean) => {
  return api.get(
    `customer/v1/saphybris/pdp-consent?isAll=${isAll ? 'true' : 'false'}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CUSTOMER } : {}
  );
};

export const getPdpConsent = async (accessToken: string) => {
  try {
    const response = apiWithRefreshToken.get(
      'saphybris-proxy/v1/saphybris/single-id/pdp-consent-check',
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response;
  } catch (error) {
    return error.response.data.responseText;
  }
};

export default {
  getPdpAll,
  getPdpConsent,
};
